// src/screens/Admin/FeedbackManager.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import './FeedbackManager.css';

import backIcon from '../../assets/backspace-icon.png';
import deleteIcon from '../../assets/delete-outline-icon.png'; // ✅ Import delete icon

function FeedbackManager({ user }) {
  const navigate = useNavigate();
  const [feedbackList, setFeedbackList] = useState([]);

  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        const res = await api.get('/feedback');
        setFeedbackList(res.data);
      } catch (err) {
        console.error('Error fetching feedback:', err);
      }
    };
    fetchFeedback();
  }, []);

  const handleDelete = async (e, id) => {
    e.stopPropagation(); // ⛔ Prevent card navigation
    const confirmed = window.confirm('Are you sure you want to delete this feedback?');
    if (!confirmed) return;

    try {
      await api.delete(`/feedback/${id}`);
      setFeedbackList(prev => prev.filter(f => f._id !== id));
    } catch (err) {
      console.error('❌ Failed to delete feedback:', err);
      alert('Failed to delete. Try again.');
    }
  };

  return (
    <div className="feedback-manager-wrapper">
      {/* 🔝 Fixed Header */}
      <div className="feedback-manager-header">
        <img src={backIcon} alt="Back" onClick={() => navigate('/admin')} />
        <h2>Feedback Inbox</h2>
      </div>

      {/* 📜 Scrollable Content */}
      <div className="feedback-manager-scroll">
        {feedbackList.length === 0 ? (
          <p className="no-feedback">No feedback submitted yet.</p>
        ) : (
          <div className="feedback-list">
            {feedbackList.map((item) => (
              <div
                key={item._id}
                className="feedback-card"
                onClick={() => navigate(`/admin/feedback/${item._id}`)}
              >
                <img
                  src={deleteIcon}
                  alt="Delete"
                  className="feedback-delete-icon"
                  onClick={(e) => handleDelete(e, item._id)}
                />
                <div className="feedback-type">
                  {item.type === 'bug' ? '🐞 Bug' : '💡 Suggestion'}
                </div>
                <div className="feedback-username">@{item.username}</div>
                <div className="feedback-date">
                  {new Date(item.createdAt).toLocaleString()}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default FeedbackManager;
